/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Exporting_ToastInputs */



/**
* | output |
* | --- |
* | "Starting video export... encoding subtitles." |
*
* @param {Video_Export_Exporting_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_exporting_toast = /** @type {((inputs?: Video_Export_Exporting_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Exporting_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Demarrage de l'exportation video... encodage des sous-titres.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Videoexport wird gestartet... Untertitel werden codiert.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avvio dell'esportazione video... codifica dei sottotitoli.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Начало экспорта видео... кодирование субтитров.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Iniciando exportación de video... codificando subtítulos.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开始导出视频……正在编码字幕。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ビデオのエクスポートを開始しています...字幕をエンコードしています。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो निर्यात शुरू हो रहा है... उपशीर्षक एन्कोड किए जा रहे हैं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Iniciando a exportação do vídeo... codificando legendas.")
	return /** @type {LocalizedString} */ ("Starting video export... encoding subtitles.")
});